"use client";

import Script from "next/script";
import { isSentinelValue } from "@/lib/env";

/**
 * X (Twitter) conversion tracking base code.
 *
 * Loads the Universal Website Tag and configures the pixel ID. The sign_up
 * conversion is fired from src/lib/analytics/analytics.x.ts via twq();
 * first-API-call is sent server-side via the X Conversions API, not twq().
 *
 * Must be a Client Component so that `process.env.NEXT_PUBLIC_*` is inlined
 * into the client bundle (which entrypoint.sh replaces at container start),
 * rather than evaluated in a statically pre-rendered Server Component at
 * build time when the env vars still hold sentinel placeholder values.
 *
 * Only renders when NEXT_PUBLIC_X_ADS_PIXEL_ID is set and we are not in a
 * test environment, so local/CI Playwright runs never load the real script.
 */
export const XAdsTrackingScript = () => {
  const pixelId = process.env.NEXT_PUBLIC_X_ADS_PIXEL_ID;

  if (!pixelId || isSentinelValue(pixelId) || process.env.NODE_ENV === "test") {
    return null;
  }

  return (
    <Script
      id="x-ads-pixel"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          twq('config','${pixelId}');
        `,
      }}
    />
  );
};
